// extracted by mini-css-extract-plugin
export default {"loginLogo":"login_loginLogo__XIZhm","loginWrapper":"login_loginWrapper__4Y1Qz"};